import { render, staticRenderFns } from "./glucosePregnancyPopup.vue?vue&type=template&id=1c76b7fb"
import script from "./glucosePregnancyPopup.vue?vue&type=script&lang=js"
export * from "./glucosePregnancyPopup.vue?vue&type=script&lang=js"
import style0 from "./glucosePregnancyPopup.vue?vue&type=style&index=0&id=1c76b7fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports